import React, { useState, useEffect } from "react";
import "./History.css"; // Import CSS
import copy from "../../assets/delete_video.svg";
import share from "../../assets/share_video.svg";
import downloadicon from "../../assets/download_video.svg";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase/firebase";
import { config } from "../../config/config";
import ReactPlayer from "react-player";
import GoogleAuth from "../../auth/GoogleAuth";

const History = ({ onDocumentSelect }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showNotificationCopy, setShowNotificationCopy] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // States for delete popup
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deletingVideoId, setDeletingVideoId] = useState(null);
  const [deleteResult, setDeleteResult] = useState(null); // 'success' or 'error'
  const [isDeleting, setIsDeleting] = useState(false);
useEffect(() => {
  if (!isLoggedIn) {
    // 🚨 logged out or token expired
    setHistoryData([]);
    setLoading(false);
    return;
  }

  const fetched = sessionStorage.getItem("hasFetchedHistory");
  const stored = sessionStorage.getItem("historyData");

  if (fetched === "true" && stored) {
    setHistoryData(JSON.parse(stored));
    setLoading(false);
    return;
  }

  fetchHistoryData();
}, [isLoggedIn]);


  const fetchHistoryData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${config.baseURL}/get_history.php`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
      const result = await response.json();

      if (response.ok && Array.isArray(result.history)) {
        setHistoryData(result.history);
        sessionStorage.setItem("historyData", JSON.stringify(result.history));
        sessionStorage.setItem("hasFetchedHistory", "true");
        setError(null);
      } else if (
        result.success === false &&
        (result.message === "Authorization token is required" ||
          result.message === "Authentication token not provided.")
      ) {
        setError("Please log in to save and view your history");
        setIsLoggedIn(false);
      } else {
        setError("History not found");
        setHistoryData([]);
      }
    } catch {
      setError("We couldn’t load your history. Please try again.");
      setHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (videoId) => {
    setDeletingVideoId(videoId);
    setShowDeletePopup(true);
    logEvent(analytics, "video_delete_initiated_FacelessVideo", {
    video_id: videoId,
  });
  };

  const handleDeleteConfirmation = async () => {
    if (!deletingVideoId) return;

    setIsDeleting(true);
    setDeleteResult(null);

    try {
      const response = await fetch(`${config.baseURL}/delete_video.php`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: localStorage.getItem("userId"),
          videoId: deletingVideoId,
        }),
      });

      const result = await response.json();

      if (result.success) {
        setDeleteResult("success");

                  logEvent(analytics, "video_deleted_FacelessVideo", {
              video_id: deletingVideoId,
            });

        setHistoryData((prevData) =>
          prevData.filter((item) => item.id !== deletingVideoId)
        );
        setTimeout(() => {
          setShowDeletePopup(false);
          setDeleteResult("");
          fetchHistoryData();
        }, 1000);
      } else {
        setDeleteResult("error");
      }
    } catch (error) {
      setDeleteResult("error");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeletePopup(false);
    setDeleteResult(null);
    fetchHistoryData();
  };

  const handleCopy = (text) => {
    const textToCopy = text.trim();

    if (!textToCopy || textToCopy === "") {
      alert("No text available to copy.");
      return;
    }

    try {
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      document.body.appendChild(textArea);

      textArea.select();
      textArea.setSelectionRange(0, 99999);

      document.execCommand("copy");

      document.body.removeChild(textArea);

      setShowNotificationCopy(true);
      setTimeout(() => setShowNotificationCopy(false), 1000);

      logEvent(analytics, "text_copied_FacelessVideo", {
        text_length: textToCopy.length,
      });
    } catch (err) {
      alert("There was an error copying the text. Please try again.");
    }
  };

  const handleShare = async (topic_type) => {
    try {
      const contentToShare = {
        title: `Create Stunning AI-Generated Videos with Ai Video Generator! 🚀`,
        text: `Experience the future of content creation! Watch this AI-generated video now and see how Ai Video Generator transforms your ideas into reality. 🌟 Don't miss out on the magic of AI!`,
        url: topic_type,
       
      };

      if (navigator.share) {
        await navigator.share(contentToShare);
           logEvent(analytics, "video_shared_FacelessVideo", {
        video_url: topic_type,
      });
      } else {
        alert("Sharing is not supported in this browser.");
      }
    } catch (error) {
      alert("Sharing failed. Please try again.");
    }
  };

  const handleDocumentClick = (item) => {
     logEvent(analytics, "video_viewed_clicked_FacelessVideo", {
    video_id: item.id,
    video_url: item.topic_type,
  });
      window.location.href = `/result?recordId=${item.video_id}&videoUrl=${item.topic_type}&edited=${item.edited}&history=true`;
  };
  useEffect(() => {
    if (showDeletePopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showDeletePopup]);

  const handleLoginSuccess = () => {
    fetchHistoryData();
  };

  if (loading) {
    return (
      <div className="loader-history">
        <p className="loader-text ">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <div className="history_null">{error}</div>
        {error === "Please log in to save and view your history" && (
          <GoogleAuth id="login_history" onLoginSuccess={handleLoginSuccess} />
        )}
      </div>
    );
  }

  const handleDownload = (topic_type) => {
    const a = document.createElement("a");
    a.href = topic_type;
    a.download = "AiVideogenerator:.mp4";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = historyData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(historyData.length / itemsPerPage);

  return (
    <>
    <div className="Historypagegrp">
      {showNotificationCopy && (
        <div className="notificationCopy">Text copied to clipboard!</div>
      )}

      {showDeletePopup && (
        <div className="delete-popup">
          <div className="delete-popup-content">
            <p>
              Are you sure you want to delete this video? This action cannot be
              undone.
            </p>
            <div className="popup-buttons">
              <button onClick={handleDeleteCancel}>Cancel</button>
              <button onClick={handleDeleteConfirmation} disabled={isDeleting}>
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
            {deleteResult && (
              <div className={`delete-result ${deleteResult}`}>
                {deleteResult === "success"
                  ? "Video deleted successfully!"
                  : "Error deleting video."}
              </div>
            )}
          </div>
        </div>
      )}
      

      {currentItems.map((item, index) => {
        const words = item.ai_result.split(" ");
        const wordLimit = 8;

        let firstWords = words.slice(0, wordLimit).join(" ");

        if (words.length > wordLimit) {
          firstWords = firstWords.trim() + "...";
        }

        return (
          <div
            className="repeating-group"
            key={index}
            onClick={() => handleDocumentClick(item)}
          >
            <div className="video-thumbnail">
              <video
                preload="metadata"
                src={item.topic_type}
                width="55%"
                style={{ borderRadius: "20px", padding: "5px" }}
              ></video>
            </div>

            <div className="text-container">
              <p>{firstWords}</p>

              <div className="icon-container">
                <button
                  className="delete_btn_history"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteClick(item.topic_type);
                  }}
                >
                  <img src={copy} alt="Delete" />
                  Delete
                </button>
                <button className="delete_btn_history">
                  <img
                    src={share}
                    alt="Share"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShare(item.topic_type);
                    }}
                  />
                </button>
              </div>
            </div>
          </div>
        );
      })}</div>

      <div className="pagination_blogspage">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <button
          onClick={() => handlePageChange(1)}
          className={currentPage === 1 ? "active" : ""}
        >
          1
        </button>

        {currentPage > 2 && currentPage < totalPages - 1 && (
          <button onClick={() => handlePageChange(currentPage - 1)}>
            {currentPage - 1}
          </button>
        )}

        {currentPage !== 1 && currentPage !== totalPages && (
          <button className="active">{currentPage}</button>
        )}

        {currentPage < totalPages - 1 && (
          <button onClick={() => handlePageChange(currentPage + 1)}>
            {currentPage + 1}
          </button>
        )}

        {currentPage < totalPages - 2 && <span>...</span>}

        {totalPages > 1 && (
          <button
            onClick={() => handlePageChange(totalPages)}
            className={currentPage === totalPages ? "active" : ""}
          >
            {totalPages}
          </button>
        )}

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default History;
